module.exports = __webpack_public_path__ + "static/media/IMG_20181123_110217_Bokeh.f1af7c52.jpg";